<template>
  <KisweOverlay
    class="kiswe-studio-overlay"
    :class="{ 'kiswe-studio-overlay--branded': props.isBranded }"
    v-bind="props"
    :style="{ ...cssVariables, ...(props.isBranded ? cssVariablesBranded : {}) }"
    :logoSrc="props.isBranded ? branding.logoUrl : ''"
    :size="props.size"
    :isModal="props.isModal"
    :showLogo="props.showLogo"
    :isStickyFooter="props.isStickyFooter"
    @close="emit('close')"
  >
    <template v-slot:top v-if="props.showLanguageSelector">
      <LanguageSelector :popperClass="props.popperClass" />
    </template>
    <template v-for="(_, slot) of slots" #[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </KisweOverlay>
</template>

<script lang="ts" setup>
import './KisweStudioOverlay.scss'
import { useSlots } from 'vue'
import { KisweOverlay, KisweSize } from 'kiswe-ui'
import { LanguageSelector } from '@/modules/translation/components'
import { useTeamBranding } from '@/modules/teams/compositions'

type KisweOverlayProps = typeof KisweOverlay['__props']
type KisweOverlayEmits = typeof KisweOverlay['__emits']

const props = withDefaults(defineProps<KisweOverlayProps & {
  showLanguageSelector?: boolean,
  popperClass?: string|null,
  isBranded?: boolean
}>(), {
  showLanguageSelector: false,
  size: KisweSize.Large,
  popperClass: null,
  isModal: true,
  showLogo: true,
  isStickyFooter: true,
  isBranded: false
})

const emit = defineEmits<KisweOverlayEmits>()

const slots = useSlots()
const { branding, cssVariables, cssVariablesBranded } = useTeamBranding()

</script>
